import Company from '../../company/company';
import GenericModel from '../../generic-model';
import IPBoardPart from './ip-board-part';

export class IPBoardPartPhoneNumber extends GenericModel {
  ipBoardPart?: IPBoardPart;
  company?: Company;
  phoneNumber?: string;
}
